// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '34870504af69ce891820228537cc2da9521772ee';
export const BUILD_NUMBER = '236';
export const BUILD_TIMESTAMP = '2026-09-15T02:31:53.190Z';
